import _ from 'underscore';

export function getSearchTermDetails(reportModalDataItems, i18n, modalTotalCount) {
  let detailStr = _.map(reportModalDataItems.slice(0, 20), value => value.SearchQuery && value.SearchQuery.Value).join(', ');
  detailStr = detailStr.replace(/,\s*$/, "");
  if (modalTotalCount > 20) {
    detailStr = i18n.getString(_TL_('{{detailStr}} + more'), { detailStr });
  }
  return detailStr;
}

export function addSearchCategoryFilter(oldFilter, searchCategory) {
  const filterBesidesAnd = [];
  _.chain(oldFilter).omit('$and').forEach((val, key) => { filterBesidesAnd.push({ [key]: val }); });
  return {
    $and: _.union(oldFilter.$and, filterBesidesAnd, [{ SearchCategory: { $eq: searchCategory } }]),
  };
}

export function showTermItem(group, setReportModalParam, reportParam) {
  setReportModalParam({
    ...reportParam,
    GridPagination: {
      RequestedPage: 1,
      RowsPerPage: 20,
    },
    columns: _.union(['SearchQuery'], reportParam.columns),
    SearchCategory: group.SearchCategory.Value,
    ParentIndex: group.key,
    filters: addSearchCategoryFilter(reportParam.filters, group.SearchCategory.Value),
  });
}

export function getGroupProps(renderGroupHeader, onToggleCollapse) {
  return {
    showEmptyGroups: true,
    onRenderHeader: renderGroupHeader,
    onToggleCollapseAll: () => _.noop,
    isAllGroupsCollapsed: true,
    headerProps: { onToggleCollapse },
    isCollapsedGroupSelectVisible: false,
  };
}
